export interface DiffLogJSON {
	id: number;
	changeLogId: number;
	field: string;
	changeType: string;
	name: string;
	originalValue: string;
	newValue: string;
}

export class DiffLog {
	constructor(
		public id: number,
		public changeLogId: number,
		public field: string,
		public changeType: string,
		public name: string,
		public originalValue: string,
		public newValue: string
	) {}

	static fromJSON(json: DiffLogJSON): DiffLog {
		return Object.assign(Object.create(DiffLog.prototype), json, {});
	}
}
